
  /* jshint ignore:start */
angular.module('mtic')
.service('encryptionService', function (
  $log,
  EventManager
) {
  var eventManager = new EventManager('encryptionService');
  var cipher_salt = 'mticSalt';
  var decipher_salt = 'verttaDecipherSecret';
  var globalCipher = cipher(cipher_salt);
  var globalDecipher = decipher(decipher_salt);
  function cipher(salt){
    let textToChars = text => text.split('').map(c => c.charCodeAt(0))
    let byteHex = n => ("0" + Number(n).toString(16)).substr(-2)
    let applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code)    

    return text => text.split('')
        .map(textToChars)
        .map(applySaltToChar)
        .map(byteHex)
        .join('')
  }   

  function decipher(salt) {
      let textToChars = text => text.split('').map(c => c.charCodeAt(0))
      let saltChars = textToChars(salt)
      let applySaltToChar = code => textToChars(salt).reduce((a,b) => a ^ b, code)
      return encoded => encoded.match(/.{1,2}/g)
          .map(hex => parseInt(hex, 16))
          .map(applySaltToChar)
          .map(charCode => String.fromCharCode(charCode))
          .join('')
  }  
  window.testPdf = function(name, count, date){           
    var uri_params = encryptionService.encryptMathleticParams(name, count, date);   
    window.open('http://localhost:8080/mathleticCertificate?'+uri_params,'_blank');
  }
  return {
    cipher: function(string){
        return globalCipher(string);
    },
    decipher: function(string){
        return globalDecipher(string);
    },
    encryptMathleticParams: function(name, count, date){
        return this.cipher('user_name')+'='+ this.cipher(name)+'&'+this.cipher('stars')+'='+ this.cipher(count+'')+'&'+this.cipher('date')+'='+ this.cipher(date+'');   
    }
    
  }
});

  /* jshint ignore:end */